import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  boxFeature: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
}));
